import React from 'react';
import './styles.css';
import ReactDOM from 'react-dom';
import Random from '../../utils/strings/Random';

class LoaderBox extends React.Component{
  constructor(props) {
    super(props);
    this.MODAL_CLASS_IN = "__react-alert-in__";

    this.close = this.close.bind(this);
  }

  componentDidMount() {
  }

//
  close(){
    this.closeLoader();
  }

//bt close handler
  handlerClose (e){
    this.closeLoader();
  }


//close alert
  closeLoader (){
    var _id = this.props.id;
    var elem = document.getElementById(_id);
    elem.parentNode.removeChild(elem);
  }

  render () {
    return (
        <div className="__loader__">
          <div className="__loader-box__">
            <div className="__loader-box-inner__">
              <div>
                <div className="simple-loader-title">{this.props.title}</div>
                <div className="linear-activity">
                    <div className="indeterminate"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
};

const MODAL_CLASS_WRAPPER = "__react-alert-class__";


class Loader {
  constructor(__args__) {
    //this.init(__args__);

  }
  static ANIMATION_INCREASE = "increase";

  close (){
    this.alert.close();
  }

  open(__props__){
    //create an element that will create our overlay
    const container = document.createElement("div");
    var _randomId = Random(5);
    container.setAttribute("id", _randomId);
    container.setAttribute("class", MODAL_CLASS_WRAPPER);
    document.body.appendChild(container);

    var overlay = ReactDOM.render(<LoaderBox title={__props__.title} id={_randomId}/>, document.getElementById(_randomId));
    this.alert = overlay;
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/loader/Loader.js